/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { CertificateResource, ResourceCollection } from "@octopusdeploy/octopus-server-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { repository } from "~/clientInstance";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent";
import type { PageAction, PrimaryPageAction } from "~/components/PageActions/PageActions";
import PaperLayout from "~/components/PaperLayout";
import { isAllowed } from "~/components/PermissionCheck/PermissionCheck";
import SidebarLayout from "~/components/SidebarLayout/SidebarLayout";
import CertificateSearch from "~/components/form/CertificateSearch/CertificateSearch";
import { timeOperationOptions } from "~/utils/OperationTimer/timeOperation";
import LibraryLayout from "../LibraryLayout/LibraryLayout";
import type { CertificateInteractionEvent } from "./Certificate/amplitudeAnalytics";
import { useDispatchCertificateInteraction } from "./Certificate/amplitudeAnalytics";
import CertificateOnboarding from "./CertificateOnboarding/CertificateOnboarding";
import CertificateSidebar from "./CertificateSidebar";
interface CertificatesPageProps {
    spaceId: string;
    analyticsDispatch: (event: CertificateInteractionEvent) => void;
}
interface CertificatesState extends DataBaseComponentState {
    certificates?: ResourceCollection<CertificateResource>;
}
class CertificatesPage extends DataBaseComponent<CertificatesPageProps, CertificatesState> {
    constructor(props: CertificatesPageProps) {
        super(props);
        this.state = {
            certificates: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const certificates = await repository.Certificates.list();
            this.setState({
                certificates,
            });
        }, { timeOperationOptions: timeOperationOptions.forInitialLoad() });
    }
    render() {
        const addCertificatePageAction: PrimaryPageAction = {
            type: "navigate",
            hasPermissions: isAllowed({ permission: Permission.CertificateCreate, wildcard: true }),
            label: "Add certificate",
            path: links.createCertificatePage.generateUrl({ spaceId: this.props.spaceId }),
            onClick: () => {
                this.props.analyticsDispatch({ type: "Add Certificate", Location: "Page" });
            },
        };
        const archivePageAction: PageAction = {
            type: "navigate",
            buttonType: "secondary",
            label: "View Archive",
            path: links.archiveCertificatePage.generateUrl({ spaceId: this.props.spaceId }),
        };
        const sidebar = this.state.certificates && this.state.certificates.TotalResults > 0 ? <CertificateSidebar /> : null;
        const content = this.state.certificates && (this.state.certificates.TotalResults > 0 ? <CertificateSearch certificates={this.state.certificates} doBusyTask={this.doBusyTask}/> : <CertificateOnboarding />);
        return (<LibraryLayout spaceId={this.props.spaceId}>
                <PaperLayout title="Certificates" primaryAction={addCertificatePageAction} pageActions={[archivePageAction]} busy={this.state.busy} errors={this.errors}>
                    <SidebarLayout sideBar={sidebar}>{content}</SidebarLayout>
                </PaperLayout>
            </LibraryLayout>);
    }
    static displayName = "CertificatesPage";
}
const CertificatesPageFC = (props: Omit<CertificatesPageProps, "analyticsDispatch">) => {
    const analyticsDispatch = useDispatchCertificateInteraction();
    return <CertificatesPage analyticsDispatch={analyticsDispatch} {...props}/>;
};
export default CertificatesPageFC;
